// Portal API Configuration
export const config = {
    API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5002/api',
    RFQ_MODULE_URL: process.env.REACT_APP_RFQ_URL || 'http://localhost:3000',
    CHECKER_MODULE_URL: process.env.REACT_APP_CHECKER_URL || 'http://localhost:3002',
    INVOICES_MODULE_URL: process.env.REACT_APP_INVOICES_URL || 'http://localhost:3003',
    ENV: process.env.REACT_APP_ENV || 'development'
};

// Module URL overrides — frontend env vars take priority over backend-provided URLs
export const MODULE_URL_OVERRIDES: Record<string, string> = {
    'rfq': config.RFQ_MODULE_URL,
    'invoice-checker': config.CHECKER_MODULE_URL,
    'invoice-management': config.INVOICES_MODULE_URL,
    // logs/scraper/mail kasıtlı olarak burada YOK: URL'leri portal backend'inin
    // env'inden gelir (LOGS_MODULE_URL vb.), frontend override gerekmez.
};

// API endpoints matching RFQ config structure
export const API_ENDPOINTS = {
    BASE_URL: config.API_BASE_URL,

    // Auth endpoints
    REGISTER: `${config.API_BASE_URL}/register`,
    VERIFY: `${config.API_BASE_URL}/verify`,
    RESEND_VERIFICATION: `${config.API_BASE_URL}/resend-verification`,
    MICROSOFT_LOGIN: `${config.API_BASE_URL}/microsoft/login`,

    // Users endpoints - EXPLICITLY DEFINED
    USERS: `${config.API_BASE_URL}/users`,

    LOGIN: `${config.API_BASE_URL}/users/login`,
    FORGOT_PASSWORD: `${config.API_BASE_URL}/users/forgot-password`,
    RESET_PASSWORD: `${config.API_BASE_URL}/users/reset-password`,

    // Modules endpoints
    MODULES: `${config.API_BASE_URL}/modules`,
    MODULE_REDIRECT: (moduleId: string) => `${config.API_BASE_URL}/modules/${moduleId}/redirect`
};
